import { FormFieldTypes } from "../../../../../../components/forms/libs/data/formFieldType";
import { validationTypes } from "../../../../../../components/forms/libs/data/ValidationTypes";
import TitleWrapper from "../../../../../../components/ui/titlewrapper/TitleWrapper";

const initState = {
    isRequireAdditionalInformation: 'no'
};

export const AdditionalQuestionsFormData = {
    name: "AdditionalQuestionsFormData",
    initialState: initState,
    section: [
        {
            title: "Additional Questions Section",
            row: {},
            style: {
                sectionStyle: "verticle-form mb-3 form-card row",
            },

            wrapperTemplate: <TitleWrapper title="Additional Questions" />,

            fields: [
                {
                    id: "isRequireAdditionalInformation",
                    label: "",
                    Field_Name: "Additional Questions",
                    fieldType: FormFieldTypes.RADIOBUTTON,
                    dataField: "isRequireAdditionalInformation",
                    fieldSetting: {
                        allowSpace: true,
                        options: [
                            {
                                value:
                                    "no",
                                label:
                                    "I do not require any additional information from the attendee.",
                            },
                            {
                                value:
                                    "yes",
                                label:
                                    "I would like to ask the attendee some additional questions before they complete their booking. Maximum 5 questions.",
                            },
                        ],
                    },
                    //  validation: [{ type: validationTypes.REQUIRE }],
                    style: {
                        containerCss: "col-lg-12 radioStyle col-md-12 ",
                    },
                },
            ],
        },
    ],
    formSetting: {
        isViewOnly: true,
    },
};

export const DietryRequirementFormData = {
    name: "DietryRequirementFormData",
    initialState: { isDietaryRequirements: 'no' },
    section: [
        {
            title: "Dietary Requirement Section",
            row: {},
            style: {
                sectionStyle: "verticle-form mb-3 form-card row",
            },

            wrapperTemplate: <TitleWrapper title="Dietary Requirement" />,

            fields: [
                {
                    id: "isDietaryRequirements",
                    label: "",
                    Field_Name: "Dietary Requirement",
                    fieldType: FormFieldTypes.RADIOBUTTON,
                    dataField: "isDietaryRequirements",
                    fieldSetting: {
                        allowSpace: true,
                        options: [
                            {
                                value: "no",
                                label: "No dietary requirement",
                            },
                            {
                                value: "yes",
                                label: "There is dietary requirement",
                            },
                        ],
                    },
                    //validation: [{ type: validationTypes.REQUIRE }],
                    style: {
                        containerCss: "col-lg-4 radioStyle col-md-4 ",
                    },
                },
            ],
        },
    ],
    formSetting: {
        isViewOnly: false,
    },
};
